import * as React from 'react';
import { RefreshSubmenuCallback } from 'grouped-combobox-core';
import { IFont, IFontPickerIconResources } from '../FontPicker/FontPicker.types.shared';
import { DefaultStringResources } from './defaultStringResources';
import { IStringResources } from '../reka/FontPicker.types.base';

export type GlobalContext = {
    isSubscriber: boolean;
    /**
     * Callback for when a font icon button is clicked.
     * @param font - The font object whose icon button is clicked.
     * @param isPinned - Indicates if the specified font is currently pinned.
     * @param refreshContainingMenu - A callback which, when invoked, will cause the submenu that contains this font variant to re-render.
     */
    fontIconButtonClicked: (
        font: IFont,
        isPinned: boolean,
        ev?: React.KeyboardEvent<unknown> | React.MouseEvent<unknown>,
        refreshContainingMenu?: RefreshSubmenuCallback
    ) => void;
    stringResources: IStringResources;
    iconResources?: IFontPickerIconResources;
};

export const AppContext = React.createContext<GlobalContext>({
    isSubscriber: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    fontIconButtonClicked: () => {},
    stringResources: DefaultStringResources,
});

AppContext.displayName = 'FontPickerContext';
